import { component } from 'picoapp';

export default component((node, ctx) => {
  const searchTrigger = node.querySelector('[data-trigger="search"]');

  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      ctx.emit('searchdrawer:toggle');
    });
  }
});
